import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import './ContentSlider.css';

export const ContentSlider = ({ children, size }) => {
  const slideSize = size => {
    switch (size) {
      case 'five-wide':
        return 5;
      case 'four-wide':
        return 4;
      case 'three-wide':
        return 3;
      case 'two-wide':
        return 2;
      default:
        return 1;
    }
  };
  const slidesToShowAboveMobile =
    slideSize(size) > children.length ? children.length - 0.5 : slideSize(size);

  const sliderSettings = {
    centerMode: true,
    centerPadding: '0px',
    slidesToShow: slidesToShowAboveMobile,
    draggable: false,
    responsive: [
      {
        breakpoint: 989,
        settings: {
          centerMode: false,
          infinite: false,
          centerPadding: '0px',
          slidesToShow:
            slidesToShowAboveMobile <= 3 ? slidesToShowAboveMobile : 3.5
        }
      },
      {
        breakpoint: 640,
        settings: {
          centerMode: false,
          infinite: false,
          centerPadding: '0px',
          slidesToShow: slideSize(size) > 1 ? 1.5 : 1
        }
      }
    ]
  };

  return (
    <div className="content-slider">
      <Slider {...sliderSettings}>{children}</Slider>
    </div>
  );
};

export default ContentSlider;



// WEBPACK FOOTER //
// ./src/components/landingPage/ContentSlider/ContentSlider.js